"use client";
import * as React from "react";
const SvgExpandLessRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 8", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.3 1 .7 5.59A1 1 0 1 0 2.13 7L6 3.12 9.89 7a1 1 0 1 0 1.4-1.41L6.72 1A1 1 0 0 0 5.3 1" }));
export {
  SvgExpandLessRound as default
};
